<div class="d-flex flex-column offcanvas-wrapper">
    <div class="offcanvas-header" [ngClass]="headerClasses()">
        <div class="d-flex align-items-center">
            @if (offcanvasTitleIcon) {
                <fa-icon [icon]="offcanvasTitleIcon" size="lg" class="me-2" [ngClass]="offcanvasTitleIconClasses()"></fa-icon>
            }
            <h4 class="offcanvas-title me-3">{{ offcanvasTitle }}</h4>
            <ng-content select="[header]"></ng-content>
        </div>
        <div class="d-flex align-items-center">
            <div class="d-flex align-items-center gap-2">
                <ng-container *ngTemplateOutlet="headerAddon"></ng-container>
                @if (headerAddon) {
                    <div class="fdx-vertical-line mx-1"></div>
                }
                @if (enableMinimize) {
                    <button
                        type="button"
                        class="btn btn-ghost btn-sq"
                        title="Minimize"
                        aria-label="Minimize"
                        (click)="offcanvasMinimized.emit()">
                        <fa-icon class="no-margin" [fixedWidth]="true" [icon]="minimizeIcon"></fa-icon>
                    </button>
                }
                @if (enableFullscreen) {
                    <button
                        *ngIf="showGoFullscreenIcon; else minimize"
                        type="button"
                        class="btn btn-ghost btn-sq"
                        title="Go full screen"
                        aria-label="Go full screen"
                        (click)="onOffcanvasPanelSizeUpdate(offcanvasPanelSizeEnum.FullScreen)">
                        <fa-icon class="no-margin" [fixedWidth]="true" [icon]="goFullScreenIcon"></fa-icon>
                    </button>
                    <ng-template #minimize>
                        <button
                            type="button"
                            class="btn btn-ghost btn-sq"
                            title="Exit full screen"
                            aria-label="Exit full screen"
                            (click)="onOffcanvasPanelSizeUpdate(offcanvasPanelSizeEnum.Original)">
                            <fa-icon class="no-margin" [fixedWidth]="true" [icon]="exitFullScreenIcon"></fa-icon>
                        </button>
                    </ng-template>
                }
                @if ((enableMinimize || enableFullscreen) && !headerAddon) {
                    <div class="fdx-vertical-line mx-1"></div>
                }
                <button
                    type="button"
                    class="btn btn-ghost btn-sq"
                    data-bs-dismiss="offcanvas"
                    title="Close"
                    aria-label="Close"
                    (click)="dismissOffcanvasWithX()"
                    [disabled]="closeDisabled">
                    <fa-icon class="no-margin" [fixedWidth]="true" size="lg" [icon]="closeIcon"></fa-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="offcanvas-body" tabindex="-1" [ngClass]="bodyClasses">
        <ng-content></ng-content>
    </div>
    <div class="offcanvas-footer" [ngClass]="footerClasses">
        <ng-content select="[footer]"></ng-content>
    </div>
</div>
